import { useEffect } from "react";
import { axiosPrivateMultipart } from "../api/axios";
import useRefreshToken from "./useRefreshToken";
import useLogout from "./useLogout";
// import { getUserDataFromLocalStorage } from "../utils";

const useAxiosPrivateMultipart = (userData) => {
  const refresh = useRefreshToken();
  const logout = useLogout();
  // const userData = getUserDataFromLocalStorage();
  // console.log("Refresh token----", userData?.access_token)

  useEffect(() => {
    const requestIntercept = axiosPrivateMultipart.interceptors.request.use(
      (config) => {
        if (!config.headers.Authorization) {
          config.headers.Authorization = `Bearer ${userData?.access_token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivateMultipart.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        if (error?.response?.status === 401) {
          await logout();
        } else if (error?.response?.status === 403 && !prevRequest?.sent) {
          prevRequest.sent = true;
          const newAccessToken = await refresh();
          prevRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return axiosPrivateMultipart(prevRequest);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivateMultipart.interceptors.request.eject(requestIntercept);
      axiosPrivateMultipart.interceptors.response.eject(responseIntercept);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, refresh]);

  return axiosPrivateMultipart;
};

export default useAxiosPrivateMultipart;
